interface LoadingStateProps {
  message?: string;
  fullPage?: boolean;
  className?: string;
}

export default function LoadingState({ 
  message = 'Loading...', 
  fullPage = false,
  className = ''
}: LoadingStateProps) {
  const containerClasses = fullPage 
    ? 'min-h-[60vh] flex items-center justify-center'
    : 'py-16 sm:py-20 flex items-center justify-center';
  
  return (
    <div className={containerClasses}>
      <div className={`text-center ${className}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-base sm:text-lg text-gray-600">{message}</p>
      </div>
    </div>
  );
}
